import _ from 'lodash'
import enabled from '../../helpers/enabled'

export default (form) => (
  _.map(enabled(form, 'oneTimeCosts'), ({ label, value }) => ({
    label,
    value: _.toNumber(value),
  }))
)
